import React, { useState } from "react";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";
import { toast } from "sonner";
import { Mail, ArrowLeft, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [debugLink, setDebugLink] = useState(null);

  const handleMagicLink = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Por favor introduz o teu email");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/auth/magic-link`, {
        email: email.toLowerCase().trim()
      });
      
      setMagicLinkSent(true);
      toast.success("Link de acesso enviado para o teu email!");
      
      if (response.data.debug_link) {
        setDebugLink(response.data.debug_link);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao enviar link");
    } finally {
      setIsLoading(false);
    }
  };

  if (magicLinkSent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f5f5f5] px-4">
        <Card className="w-full max-w-md border-0 shadow-lg">
          <CardContent className="pt-8 pb-8 text-center">
            <div className="w-16 h-16 bg-[#6697a4]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Mail className="h-8 w-8 text-[#6697a4]" />
            </div>
            <h2 className="text-2xl font-bold text-[#3d5a63] mb-2">Verifica o teu email!</h2>
            <p className="text-gray-500 mb-6">
              Enviámos um link de acesso para<br />
              <strong className="text-[#3d5a63]">{email}</strong>
            </p>
            <p className="text-sm text-gray-400 mb-6">
              O link é válido por 30 minutos.
            </p>
            
            {debugLink && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-yellow-700 mb-2">
                  <strong>Modo de Desenvolvimento:</strong><br />
                  Email não configurado. Usa este link:
                </p>
                <a 
                  href={debugLink}
                  className="text-sm text-[#6697a4] underline break-all"
                >
                  {debugLink}
                </a>
              </div>
            )}
            
            <Button
              variant="outline"
              onClick={() => setMagicLinkSent(false)}
              className="w-full"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f5f5] px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/">
            <img 
              src="/assets/images/logo.png" 
              alt="Apúlia Surf School" 
              className="h-20 w-auto mx-auto mb-4"
            />
          </Link>
          <h1 className="text-2xl font-bold text-[#3d5a63]">Bem-vindo!</h1>
          <p className="text-gray-500">Entra na tua conta ou regista-te</p>
        </div>

        <Card className="border-0 shadow-lg">
          <CardContent className="pt-6 pb-6">
            <form onSubmit={handleMagicLink} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="exemplo@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1"
                  data-testid="login-email-input"
                />
              </div>
              <Button 
                type="submit" 
                className="w-full bg-[#6697a4] hover:bg-[#3d5a63]"
                disabled={isLoading}
                data-testid="login-submit-btn"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    A enviar...
                  </>
                ) : (
                  <>
                    <Mail className="mr-2 h-4 w-4" />
                    Receber Link de Acesso
                  </>
                )}
              </Button>
              <p className="text-xs text-center text-gray-400">
                Vais receber um link no teu email que te permite entrar sem password.
              </p>
            </form>
          </CardContent>
        </Card>

        <div className="text-center mt-6">
          <Link to="/" className="text-[#6697a4] hover:text-[#3d5a63] text-sm">
            <ArrowLeft className="inline mr-1 h-4 w-4" />
            Voltar ao início
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
